import React from 'react';
import { Button as ButtonAntD, ButtonProps } from 'antd';

export const Button: React.FC<ButtonProps> = (props) => {
	return <ButtonAntD {...props} />;
};
